import { shuffle } from '~/lib/shuffle';
import {
  LayoutListDefinition,
  LAYOUT_LIST,
  TEXT,
  QUIZ_MATCH_BLOCK,
  QuizMatchBlockDefinition,
  CardDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Quiz13Steps: Translator = sequence => {
  const images: any[] = [];

  sequence?.items?.forEach(item => {
    if (item.__typename === 'Card') {
      if (item.pictures) {
        images.push(item.pictures[0]);
      } else {
        images.push(false);
      }
    }
  });

  return translate(sequence, item => {
    if (item.__typename === 'Question') {
      const listItem: LayoutListDefinition = {
        id: `${item.id}.text-list`,
        type: LAYOUT_LIST,
        values: {
          padded: true,
          align: 'center',
          height: 'auto'
        },
        items: []
      };
      if (item.subtitle) {
        listItem.items.push({
          id: `${item.id}_subtitle`,
          type: TEXT,
          values: {
            value: item.subtitle,
            variant: 'sub_heading',
            icon: item.icon
          },
          items: []
        });
      }

      if (item.title) {
        listItem.items.push({
          id: `${item.id}_title`,
          type: TEXT,
          values: {
            value: item.title,
            variant: 'heading1'
          },
          items: []
        });
      }

      if (item.body) {
        listItem.items.push({
          id: `${item.id}_body`,
          type: TEXT,
          values: {
            value: item.body,
            align: 'center'
          },
          items: []
        });
      }

      listItem.items.push({
        id: `${item.id}.quiz-match`,
        type: QUIZ_MATCH_BLOCK,
        values: {
          variant: 'drag',
          leftItems: shuffle(
            item.items
              ? [...item.items]
                  .sort(
                    (a: any, b: any) => (a.position || 0) - (b.position || 0)
                  )
                  .map(({ id, value }, i) => {
                    return {
                      label: value || 'Question text',
                      pairId: id,
                      image: images[i]
                    };
                  })
              : []
          ),
          rightItems: item.items
            ? [...item.items]
                .sort((a: any, b: any) => (a.position || 0) - (b.position || 0))
                .map(({ id, feedback }) => {
                  return {
                    label: feedback,
                    pairId: id
                  };
                })
            : []
        }
      } as QuizMatchBlockDefinition);

      return listItem;
    }
    return null;
  });
};
